import type { UserInfo } from "#/entity";
import { buildApiUrl } from "@/config/api";
import apiClient from "../apiClient";

export interface SignInReq {
	email: string;
	password: string;
}

export interface SignUpReq extends SignInReq {
	email: string;
}
export interface SignInRes {
	message: string;
	token: string;
	permissions: string[];
	user: {
		id: number;
		name: string;
	};
	/** Fájl-hozzáférési token a /files útvonalhoz (a szerver adja). */
	file_token?: string;
}

export enum UserApi {
	SignIn = "/auth/signin",
	SignUp = "/auth/signup",
	Logout = "/auth/logout",
	Refresh = "/auth/refresh",
	User = "/user",
}

const signin = async (data: SignInReq): Promise<SignInRes> => {
	const response = await fetch(buildApiUrl("/login"), {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
		},
		body: JSON.stringify(data),
	});

	if (!response.ok) {
		const errorData = await response.json();
		throw new Error(errorData.message || "Login failed");
	}

	return response.json();
};

const getAllUsers = async (token: string): Promise<{ message: string; data: UserInfo[] }> => {
	const response = await fetch(buildApiUrl("/users"), {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: `Bearer ${token}`,
		},
	});

	if (!response.ok) {
		const errorData = await response.json();
		throw new Error(errorData.message || "Failed to fetch users");
	}

	return response.json();
};

const signup = (data: SignUpReq) => apiClient.post<SignInRes>({ url: UserApi.SignUp, data });
const logout = () => apiClient.get({ url: UserApi.Logout });
const findById = (id: string) => apiClient.get<UserInfo[]>({ url: `${UserApi.User}/${id}` });

export default {
	signin,
	signup,
	findById,
	logout,
	getAllUsers,
};
